import { runLobby } from './ui/lobby';
import { Connection } from './net/Connection';
import { Game } from './game/Game';
import { showToast } from './ui/toast';
import { api } from './net/api';
import { preloadCoreTextures } from './world/coreTextures';

async function boot(): Promise<void> {
  const { profile, worldId } = await runLobby();
  const [{ connection, init }, library] = await Promise.all([
    Connection.connect(worldId),
    api.blockLibrary(),
    preloadCoreTextures(),
  ]);
  new Game(profile, connection, init, library).start();
}

boot().catch((e) => {
  console.error(e);
  showToast(e instanceof Error ? e.message : 'Failed to start');
});
